var map = {
	"./Landscape 1200 x 628 ostlind.jpg": 880,
	"./Landscape 1200 x 628.jpg": 873,
	"./Lg Square OSTLIND text.jpg": 199,
	"./Lg Square TEXT.jpg": 104,
	"./Med rectangle TEXT.jpg": 779,
	"./Med rectangle theme color.jpg": 466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 258;